import $ from "jquery";
import Rx from "rxjs/Rx";

/**
 * Public API:
 * - event areaRowSelectionUpdated$ {AreaFiltersRowComponent}
 * - setActiveVisualState()
 * - setPassiveVisualState()
 */

import { AreaFilterComponent, areaFilterSelected$ } from "./area-filter.component";

const areaRowSelectionUpdatedSource = new Rx.Subject();
/**
 * {AreaFiltersRowComponent}
 */
export const areaRowSelectionUpdated$ = areaRowSelectionUpdatedSource.asObservable();

export class AreaFiltersRowComponent {
    /**
     * @param {Object} node - Jquery node. Unique for every AreaFiltersRowComponent class instance.
     */
    constructor(node) {
        this.node = node;
        this.areaFilters = [];
        this.selectedAreaFilter = null;

        this.initialize();
    }

    initialize() {
        this.initializeAreaFilters();
        this.subscribeOnAreaFilterSelected$();
    }

    subscribeOnAreaFilterSelected$() {
        areaFilterSelected$.subscribe((args) => {
            if (args.row !== this) return;
            this.selectedAreaFilter = args.filter;
            areaRowSelectionUpdatedSource.next(this);
        });
    }

    initializeAreaFilters() {
        const scope = this;
        this.node.find(".custom-area-filter-component").each(function createAreaFilter() {
            scope.areaFilters.push(new AreaFilterComponent($(this), scope));
        });
    }

    setActiveVisualState() {
        this.node.addClass("active");
    }

    setPassiveVisualState() {
        this.node.removeClass("active");
    }
}
